import { ObjectList } from "web/components"
import useViewOrEditTopicModal from "web/components/ViewOrEdit/ViewOrEditTopic"

import {
  useDealComparableTopicRecordsView,
  useFeatureFlag,
  useRemoveDealComparables,
  useTopics,
} from "web/hooks/data"

import { useCurrentTLO } from "web/hooks/context"
import { NavigationProvider } from "web/contexts"

import FindComparablesButton from "../shared/FindComparablesButton"
import SelectReferencesButton from "../shared/SelectReferencesButton"
import routes from "web/routes/constants"

import { TrashIcon } from "@heroicons/react/24/outline"

export default function SavedComparables({
  subjectType,
  topicName,
  baseUrl,
  canRedirectToRootUrl,
}) {
  const { userCan, data: deal } = useCurrentTLO()

  const topics = useTopics()

  const topic = topics.find(
    (topic) =>
      topic.subject_type.toLowerCase() === subjectType &&
      topic.name === topicName
  )

  const removeComparables = useRemoveDealComparables({ deal, topic })

  const [viewGroup] = useDealComparableTopicRecordsView({
    dealId: deal.id,
    topicId: topic.id,
  })

  const useSSRTopicRecordModals = useFeatureFlag("ssr_topic_record_modals")

  const viewOrEditTopicModal = useViewOrEditTopicModal({ subjectType, topic })

  async function handleTopicRecordClick(record, list) {
    if (useSSRTopicRecordModals) {
      window.Turbo.visit(
        routes.ssrEditTopicRecord({
          subjectType: subjectType,
          subjectId: record.subject_id,
          topicName: topicName,
          id: record.id,
          isCrossSubject: true,
        }),
        {
          frame: "modal",
        }
      )
    } else {
      await viewOrEditTopicModal({
        recording: record,
        isCrossSubject: true,
      })

      list.refresh()
    }
  }

  async function handleRemoveDealComparable({
    all: topicRecordComparables,
    selected: comparables,
  }) {
    await removeComparables(comparables.filter((el) => el.id !== deal.id))
    topicRecordComparables.refresh()
  }

  const selectedItemActions = []
  if (userCan("update")) {
    selectedItemActions.push({
      label: "Remove",
      icon: TrashIcon,
      action: handleRemoveDealComparable,
    })
  }

  return (
    <NavigationProvider viewGroup={viewGroup} viewId={null}>
      <div className="-mx-3 flex min-h-0 grow flex-col lg:-mx-5">
        <ObjectList
          subjectType={subjectType}
          topic={topic}
          parentSubjectType="deal"
          parentSubjectId={deal.id}
          fetchURL={`/deals/${deal.id}/comparables/topics/${topic.id}/records`}
          exportPath={`/deals/${deal.id}/comparables/topics/${topic.id}`}
          listType="deal_comparable_topic_records"
          availableViews={["table", "map", "compare"]}
          defaultView="table"
          onItemClick={handleTopicRecordClick}
          selectedItemActions={selectedItemActions}
          customListActions={
            <div className="space-x-2">
              <FindComparablesButton baseURL={baseUrl} />
              <SelectReferencesButton baseURL={baseUrl} />
            </div>
          }
          rootUrl={baseUrl}
          canRedirectToRootUrl={canRedirectToRootUrl}
        />
      </div>
    </NavigationProvider>
  )
}
